import { useHistory } from 'react-router-dom';
import { func } from 'prop-types';
import CheckCircleIcon from 'images/pro/greenCheck-filled.svg';
import { pushHistory } from 'utils/client_side_routing_helpers';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import Plan from 'types/Plan';
import CurrencyCode from 'types/CurrencyCode';
import GiftPlan from 'components/GiftFlow/GiftPlan';
import { FormattedMessage } from 'react-intl';
import * as styles from './GiftingHeader.module.scss';
import BulletList from '../../../shared/text/BulletList';
import Expandable from '../../../shared/Expandable';

type GiftingHeaderProps = {
  plan: Plan;
  currencyCode: CurrencyCode;
};

const FEATURES = [
  <FormattedMessage defaultMessage="Download maps to stay on track without service" />,
  <FormattedMessage defaultMessage="Never miss a turn with off-route notifications" />,
  <FormattedMessage defaultMessage="Keep friends and family informed with Lifeline" />,
  <FormattedMessage defaultMessage="See air quality, pollen, & weather details on any map" />
];

const BulletIcon = () => <img src={CheckCircleIcon} alt="checkmark" className={styles.checkMarkIcon} />;

const GiftingHeader = ({ plan, currencyCode }: GiftingHeaderProps) => {
  const languageRegionCode = useLanguageRegionCode();
  const history = useHistory();

  const handleSubmit = () => {
    pushHistory('/gift/customize', history, languageRegionCode);
  };

  const bulletList = <BulletList classes={styles.bulletList} bullet={<BulletIcon />} list={FEATURES} />;

  return (
    <section className={styles.container}>
      <div className={styles.banner} />
      <div className={styles.featuresAndChoose}>
        <div className={styles.features}>
          <h1 className={styles.featureHeader} data-testid="give_the_gift">
            <FormattedMessage defaultMessage="Give the gift of adventure" />
          </h1>
          <div className={styles.mobileBulletList}>
            <Expandable title={<FormattedMessage defaultMessage="Features designed for all" />} classes={styles.bulletList}>
              {bulletList}
            </Expandable>
          </div>
          <div className={styles.desktopBulletList}>{bulletList}</div>
        </div>
        <div className={styles.planType}>
          <GiftPlan currencyCode={currencyCode} handleSubmit={handleSubmit} plan={plan} />
        </div>
      </div>
    </section>
  );
};

GiftingHeader.contextTypes = {
  dispatchGiftFlow: func
};

export default GiftingHeader;
